import { Skeleton } from "@/components/skeleton";

type ContentKind = "editor" | "selects";

const SECTIONS: { content: ContentKind; titleWidth: string }[] = [
  { content: "selects", titleWidth: "w-32" },
  { content: "editor", titleWidth: "w-40" },
  { content: "editor", titleWidth: "w-32" },
];

function SectionContent({ kind }: { kind: ContentKind }) {
  switch (kind) {
    case "editor": {
      return <Skeleton className="h-40 w-full rounded-lg" />;
    }
    case "selects": {
      return (
        <>
          <Skeleton className="h-10 w-full rounded-lg" />
          <Skeleton className="h-10 w-full rounded-lg" />
        </>
      );
    }
  }
}

function SectionSkeleton({
  content,
  titleWidth,
}: {
  content: ContentKind;
  titleWidth: string;
}) {
  return (
    <div className="rounded-xl bg-bg-secondary border border-border-secondary">
      <div className="flex w-full items-center gap-xs p-xl justify-between">
        <div className="flex min-w-0 flex-1 items-center gap-lg">
          <Skeleton className="size-8 shrink-0 rounded-md" />
          <Skeleton className={`h-5 ${titleWidth} max-w-[60%]`} />
        </div>
        <Skeleton className="size-6 shrink-0 rounded-md" />
      </div>

      <div className="mx-xl h-px bg-border-primary" />

      <div className="p-xl">
        <div className="flex flex-col gap-lg">
          <SectionContent kind={content} />
        </div>
      </div>
    </div>
  );
}

export function RequestFormSkeleton() {
  return (
    <>
      <div className="py-md">
        <Skeleton className="h-6 w-28" />
      </div>

      <div className="flex flex-col gap-xl">
        {SECTIONS.map((section, index) => (
          <SectionSkeleton
            content={section.content}
            key={index}
            titleWidth={section.titleWidth}
          />
        ))}
      </div>
    </>
  );
}
